import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Dashboard.css"; // Arquivo CSS para estilização

function Dashboard() {
  const [urls, setUrls] = useState([]); // Lista de URLs
  const [newUrl, setNewUrl] = useState(""); // URL para adicionar
  const [newDescription, setNewDescription] = useState(""); // Descrição para adicionar
  const [newCode, setNewCode] = useState(""); // Código personalizado opcional
  const [modalData, setModalData] = useState(null); // Dados para o modal de edição
  const [updatedUrl, setUpdatedUrl] = useState(""); // URL atualizada no modal
  const [updatedDescription, setUpdatedDescription] = useState(""); // Descrição atualizada no modal
  const [message, setMessage] = useState(""); // Mensagem de sucesso ou erro
  const [responseCode, setResponseCode] = useState(""); // Código de resposta da API
  const [recentShortUrl, setRecentShortUrl] = useState(""); // URL encurtada recém-criada

  const apiBaseUrl = "https://urlshortapi.sturion.net";

  // Função para buscar URLs da API
  const fetchUrls = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/`);
      setUrls(response.data.urls || []);
    } catch (error) {
      console.error("Erro ao buscar URLs:", error);
    }
  };

  // Função para adicionar uma nova URL
  const handleAddUrl = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/`, {
        url: newUrl,
        description: newDescription,
        code: newCode || undefined, // Envia o código apenas se for preenchido
      });
      const { code } = response.data;
      setResponseCode(code); // Armazena o código de resposta
      // Obtém a URL base local dinamicamente
      const baseUrl = window.location.origin;
      const shortUrl = `${baseUrl}/${code}`;
      setMessage(`URL encurtada criada: ${shortUrl}`);
      setRecentShortUrl(shortUrl);

      setNewUrl("");
      setNewDescription("");
      setNewCode("");
      fetchUrls(); // Atualiza a lista de URLs
    } catch (error) {
      setMessage("Erro ao adicionar URL. Verifique os dados e tente novamente.");
      console.error("Erro ao adicionar URL:", error);
    }
  };

  // Função para copiar a URL encurtada para a área de transferência
  const handleCopyUrl = (code) => {
    const shortUrl = `${window.location.origin}/${code}`;
    console.log("URL copiada:", shortUrl);
    navigator.clipboard.writeText(shortUrl);
    setMessage("URL copiada para a área de transferência!");
  };

  // Função para abrir o modal de edição
  const openModal = (url) => {
    setModalData(url);
    setUpdatedUrl(url.url);
    setUpdatedDescription(url.description);
  };

  // Função para atualizar uma URL
  const handleUpdateUrl = async () => {
    try {
      await axios.put(`${apiBaseUrl}/${modalData.code}`, {
        url: updatedUrl,
        description: updatedDescription,
      });
      setMessage("URL atualizada com sucesso!");
      setModalData(null); // Fecha o modal
      fetchUrls(); // Atualiza a lista de URLs
    } catch (error) {
      setMessage("Erro ao atualizar URL. Tente novamente.");
      console.error("Erro ao atualizar URL:", error);
    }
  };

  // Busca as URLs ao carregar a página
  useEffect(() => {
    fetchUrls();
  }, []);

  return (
    <div className="dashboard-container">
      <h1>Dashboard - Gerenciamento de URLs</h1>

      {/* Inputs para adicionar nova URL */}
      <div className="add-url-container">
        <h2>Adicionar Nova URL</h2>
        <input
          type="text"
          placeholder="URL"
          value={newUrl}
          onChange={(e) => setNewUrl(e.target.value)}
        />
        <input
          type="text"
          placeholder="Descrição"
          value={newDescription}
          onChange={(e) => setNewDescription(e.target.value)}
        />
        <input
          type="text"
          placeholder="Código personalizado (opcional)"
          value={newCode}
          onChange={(e) => setNewCode(e.target.value)}
        />
        <button onClick={handleAddUrl}>Adicionar</button>
        {/* Exibe a mensagem de sucesso ou erro */}
        {message && (
          <div className="message">
            <p>{message}</p>
            {recentShortUrl && (
              <button onClick={() => handleCopyUrl(responseCode)}>Copiar URL</button>
            )}
          </div>
        )}
      </div>

      {/* Lista de URLs */}
      <div className="url-list-container">
        <h2>Lista de URLs</h2>
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Descrição</th>
              <th>URL</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {urls.map((url) => (
              <tr key={url.code}>
                <td>{url.code}</td>
                <td>{url.description}</td>
                <td>{url.url}</td>
                <td>
                  <button onClick={() => handleCopyUrl(url.code)}>Copiar</button>
                  <button onClick={() => openModal(url)}>Editar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal de edição */}
      {modalData && (
        <div className="modal">
          <h2>Editar URL</h2>
          <input
            type="text"
            placeholder="URL"
            value={updatedUrl}
            onChange={(e) => setUpdatedUrl(e.target.value)}
          />
          <input
            type="text"
            placeholder="Descrição"
            value={updatedDescription}
            onChange={(e) => setUpdatedDescription(e.target.value)}
          />
          <button onClick={handleUpdateUrl}>Salvar</button>
          <button onClick={() => setModalData(null)}>Cancelar</button>
        </div>
      )}
    </div>
  );
}

export default Dashboard;